import React, { useEffect, useRef, useState } from 'react';
import SinglePlayerQuiz from './SinglePlayerQuiz';
import Leaderboard from './Leaderboard';
import GameOver from './GameOver';
import MultiplayerWaitingRoom from './MultiplayerWaitingRoom';
import MultiplayerQuiz from './MultiplayerQuiz';
import './styles.css';
import { io } from 'socket.io-client';

function App() {
  const [stage, setStage] = useState('home'); // home, singlePlayerQuiz, waitingRoom, multiplayerQuiz, game-over, leaderboard
  const [questions, setQuestions] = useState([]);
  const [finalScore, setFinalScore] = useState(0);
  const [gameEndReason, setGameEndReason] = useState('');
  const [opponentUsername, setOpponentUsername] = useState('');
  const [username, setUsername] = useState('');
  const socketRef = useRef(null);
  const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  const API_URL = process.env.REACT_APP_API_URL;
  const [isSocketReady, setIsSocketReady] = useState(false);

  // Function to initialize socket
  const initializeSocket = () => {
    if (socketRef.current) {
      socketRef.current.disconnect(); // Disconnect the old socket if it exists
      socketRef.current = null; // Clear the reference
    }
    const socket = io(SOCKET_URL); // Create a new socket connection
    socketRef.current = socket;

    socket.on('connect', () => {
      console.log('Socket connected with ID:', socket.id);
      setIsSocketReady(true);
    });

    socket.on('disconnect', () => {
      console.log('Socket disconnected');
      setIsSocketReady(false); // Update readiness state
    });

    socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      setIsSocketReady(false);
    });

    return socket;
  };

  // Function to clean up the socket
  const cleanUpSocket = () => {
    if (socketRef.current) {
      console.log('Cleaning up socket...');
      socketRef.current.disconnect();
      socketRef.current = null;
      setIsSocketReady(false);
    }
  };

  const fetchQuestions = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/questions`)
      .then((response) => response.json())
      .then((data) => {
        const shuffled = data.sort(() => 0.5 - Math.random());
        setQuestions(shuffled);
        setStage('singlePlayerQuiz');
      })
      .catch((error) => console.error('Error fetching questions:', error));
  };

  const handleMultiplayerStart = () => {
    initializeSocket(); // Reinitialize the socket for a fresh connection
    setStage('waitingRoom');
  };

  const handleReturnToHome = () => {
    cleanUpSocket(); // Ensure the socket is cleaned up
    setStage('home');
  };

  const handleSubmitScore = (name) => {
    fetch(`${API_URL}/api/leaderboard`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, score: finalScore }),
    })
      .then(() => setStage('leaderboard')) // Navigate to leaderboard after submitting
      .catch((error) => console.error('Error submitting score:', error));
  };


  const handleReturnToHomeSinglePlayer = (score, reason) => {
    setFinalScore(score);
    setStage('game-over');
  }

  const handleGameStart = (playerUsername, oppUsername) => {
    setUsername(playerUsername); // Set player's username
    setOpponentUsername(oppUsername); // Set opponent's username
    setStage('multiplayerQuiz');
    console.log("game starting");
  };

  return (
    <div className="App">
      {stage === 'home' && (
        <div>
          <h1>Ball Knowledge</h1>
          <div className="button-container">
            <button onClick={fetchQuestions}>Start Game (Single Player)</button>
            <button onClick={handleMultiplayerStart}>Start Multiplayer</button>
            <button onClick={() => setStage('leaderboard')}>View Leaderboard</button>
          </div>
        </div>
      )}

      {stage === 'singlePlayerQuiz' && <SinglePlayerQuiz questions={questions} onFinish={handleReturnToHomeSinglePlayer} />}

      {stage === 'waitingRoom' && isSocketReady && (
        <MultiplayerWaitingRoom
          onGameStart={handleGameStart}
          onCancel={handleReturnToHome}
          socket={socketRef.current}
        />
      )}

      {stage === 'multiplayerQuiz' && socketRef.current && (
        <MultiplayerQuiz
          username={username}
          opponentUsername={opponentUsername}
          socket={socketRef.current}
          onFinish={handleReturnToHome}
        />
      )}

      {stage === 'game-over' && (
        <GameOver
          score={finalScore}
          reason={gameEndReason}
          onSubmitScore={handleSubmitScore}
          onGoHome={handleReturnToHome}
        />
      )}

      {stage === 'leaderboard' && <Leaderboard onBack={() => setStage('home')} />}
    </div>
  );
}

export default App;
